import { render, staticRenderFns } from "./ArticleDealsSummary.vue?vue&type=template&id=1ae47b1a&"
import script from "./ArticleDealsSummary.vue?vue&type=script&lang=js&"
export * from "./ArticleDealsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports